<template>
  <div :class="componentClassName">
    <section class="t-sf-entry__col">
      <div class="t-sf-entry__form-wrapper">
        <a-heading class="t-sf-entry__heading" tag="h1" variant="center" :heading="heading" :subheading="subHeading" />
        <div class="t-sf-entry__body">
          <slot></slot>
        </div>
      </div>

      <o-global-footer class="t-sf-entry__footer">
        <m-link-container>
          <li><a id="help" :href="helpUrl" target="_blank">ヘルプ</a></li>
          <li><a id="privacyPolicy" :href="privacyPolicyUrl" target="_blank">プライバシーポリシー</a></li>
          <li>
            <a id="termsOfService" :href="termsUrl" target="_blank" title="別ウインドウにてPDF文書が表示されます。"
              >利用規約(1038KB)</a
            ><img src="/public/PDF_32.png" class="t-sf-entry__icon-margin" />
          </li>
        </m-link-container>
      </o-global-footer>
    </section>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';

import AHeading from '@/components/atoms/heading';
import MLinkContainer from '@/components/molecules/link-container';
import OGlobalFooter from '@/components/organisms/global-footer';

export default {
  name: 't-sf-default-entry',
  components: {
    AHeading,
    MLinkContainer,
    OGlobalFooter,
  },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    class: {
      type: String,
      default: '',
    },
    heading: {
      type: String,
      default: null,
    },
    subHeading: {
      type: String,
      default: null,
    },
    navigationItems: {
      type: Array,
      default: new Array(0),
    },
    activeNavId: {
      type: String,
      default: '',
    },
    helpUrl: {
      type: String,
      default: 'https://support.ntt.com/ccaas/inquiry/search',
    },
    privacyPolicyUrl: {
      type: String,
      default: 'https://www.ntt.com/about-us/hp/privacy.html',
    },
    termsUrl: {
      type: String,
      default: 'https://www.ntt.com/content/dam/nttcom/hq/jp/about-us/disclosure/tariff/pdf/c325.pdf',
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-sf-entry');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
};
</script>
